import { iots, tagged } from '@code-expert/prelude';
import { CourseId, SemesterId, TaskId } from '/imports/domain/identity';

export type LtiError = iots.TypeOf<typeof LtiErrorC>;

export const LtiErrorC = iots.union([
  iots.tagged(
    'courseLocked',
    iots.strict({ taskId: TaskId, semester: SemesterId, courseId: CourseId }),
  ),
  iots.tagged('creatingStudentAttemptFailed'),
  iots.tagged('invalidWorkflow'),
  iots.tagged('ltiSessionExpired'),
  iots.tagged('ltiSessionNotFound'),
  iots.tagged('ltiSessionUpdateFailed'),
  iots.tagged('ltiSessionUserMismatch'),
  iots.tagged('ltiSessionEnded'),
  iots.tagged('projectUpdateFailed'),
  iots.tagged('solvedSessionNotFound'),
  iots.tagged('studentTemplateNotFound'),
  iots.tagged('submissionDeleted'),
  iots.tagged('submissionNotFound'),
  iots.tagged('unfinishedAttempt'),
]);

export const ltiErrorAdt = tagged.build<LtiError>();
